import PropTypes from 'prop-types';

const DIRECTIONS = ['horizontal', 'vertical'];

export const DIVIDER_DIRECTIONS_PROP_TYPE = PropTypes.oneOf(DIRECTIONS);
